import React, { Component } from "react";
import classNames from "classnames";
import * as _ from "lodash";

import QuizDay, { daysInMonth, dayStrToParts, dayPartsToStr } from "./QuizDay";
import QuizNth from "./QuizNth";
import QuizMonth from "./QuizMonth";
import QuizYear from "./QuizYear";
import Logo from "./ui/Logo";

import "./Practice.css";

const KEY_PRACTICE_SETTINGS = "PRACTICE_SETTINGS";
const KEY_PRACTICE_SEED = "PRACTICE_SEED";

const validate = (val, min, max) => {
  for (let i = 0; i <= max; i++) {
    if (val === i) {
      return true;
    }
  }
  return false;
};

const curYear = new Date().getFullYear();

const formatYearRange = ([fromYear, toYear]) => {
  return fromYear === toYear ? fromYear : fromYear + " - " + toYear;
};

const getYearRange = (type, years) => {
  return type === 2
    ? [
        [2000, 2027],
        [2000, 2099],
        [1901, 2099],
        [1582, 2099],
      ][years]
    : [
        [curYear, curYear],
        [curYear - 2, curYear + 1],
        [1901, 2099],
        [1582, 2099],
      ][years];
};

export default class Practice extends Component {
  state = {};

  componentWillMount() {
    let settings = {
      years: 0,
      type: 0,
    };

    try {
      const { years, type } = JSON.parse(
        window.localStorage.getItem(KEY_PRACTICE_SETTINGS)
      );
      if (validate(type, 0, 3)) {
        settings.type = type;
      }
      if (validate(years, 0, 3)) {
        settings.years = years;
      }
    } catch (ignore) {}

    this.setState({
      settings,
    });

    this.restoreSeed();
  }

  restoreSeed = () => {
    let seed;

    try {
      seed = JSON.parse(window.localStorage.getItem(KEY_PRACTICE_SEED));
      if (
        !(
          typeof seed.random === "number" &&
          seed.random >= 0 &&
          seed.random < 1 &&
          seed.date.match(/^\d{4}-\d\d-\d\d$/)
        )
      ) {
        throw new Error();
      }
    } catch (ignore) {
      seed = this.createNewSeed();
    }

    this.setSeed(seed);
  };

  resetSeed = () => {
    const seed = this.createNewSeed();
    this.setSeed(seed);
  };

  setSeed = (seed) => {
    window.localStorage.setItem(KEY_PRACTICE_SEED, JSON.stringify(seed));
    this.setState({
      seed,
    });
  };

  createNewSeed = () => {
    const prevMonth = this.state.seed
      ? dayStrToParts(this.state.seed.date).month
      : null;
    let seed;

    do {
      seed = this.generateSeedDate();
    } while (seed.month === prevMonth);

    return {
      date: dayPartsToStr(seed.year, seed.month, seed.date),
      random: Math.random(),
    };
  };

  generateSeedDate = () => {
    const month = Math.floor(Math.random() * 12);

    const minYear = 1582;
    const maxYear = 2199;

    // Jan and Feb should be 40/60 leap-non leap
    const forceLeap = month < 2 && Math.random() < 0.4;

    let year;
    do {
      year = minYear + Math.floor(Math.random() * (maxYear - minYear));
    } while (forceLeap && year % 4 !== 0);

    const date = Math.floor(1 + Math.random() * daysInMonth(year, month));

    return {
      year,
      month,
      date,
    };
  };

  onChooseSetttingFn = _.memoize(
    (key, value) => (evt) => {
      evt.preventDefault();

      const { years, type } = this.state.settings;

      const newSettings = {
        years,
        type,
        [key]: value,
      };

      this.setState({
        settings: newSettings,
      });

      window.localStorage.setItem(
        KEY_PRACTICE_SETTINGS,
        JSON.stringify(newSettings)
      );
    },
    (key, value) => key + ":" + value
  );

  render() {
    const { seed, settings } = this.state;
    const { years, type } = settings;

    const [fromYear, toYear] = getYearRange(type, years);

    return (
      <div className="Practice">
        <header>
          <Logo />

          <div className="-buttonNav --type">
            <strong>Type:</strong>
            <span>
              <OptionButton
                on={type === 0}
                onClick={this.onChooseSetttingFn("type", 0)}
              >
                Calculate Weekday
              </OptionButton>
              <OptionButton
                on={type === 1}
                onClick={this.onChooseSetttingFn("type", 1)}
              >
                Calculate Date
              </OptionButton>
              <OptionButton
                on={type === 2}
                onClick={this.onChooseSetttingFn("type", 2)}
              >
                Year Part
              </OptionButton>
              <OptionButton
                on={type === 3}
                onClick={this.onChooseSetttingFn("type", 3)}
              >
                Month Part
              </OptionButton>
            </span>
          </div>

          {type !== 3 && (
            <div className="-buttonNav --years">
              <strong>Years:</strong>
              <span>
                {[0, 1, 2, 3].map((n) => (
                  <OptionButton
                    key={n}
                    on={years === n}
                    onClick={this.onChooseSetttingFn("years", n)}
                  >
                    {formatYearRange(getYearRange(type, n))}
                  </OptionButton>
                ))}
              </span>
            </div>
          )}
        </header>

        <div className="-content">
          {type === 0 && [
            <QuizDay
              isPractice
              key={fromYear + "-" + toYear}
              fromYear={fromYear}
              toYear={toYear}
              yearsOptionNumber={years}
              seed={seed}
              resetSeed={this.resetSeed}
            />,
          ]}

          {type === 1 && [
            <QuizNth
              key={fromYear + "-" + toYear}
              fromYear={fromYear}
              toYear={toYear}
              seed={seed}
              resetSeed={this.resetSeed}
            />,
          ]}

          {type === 2 && [
            <QuizYear
              key={fromYear + "-" + toYear}
              fromYear={fromYear}
              toYear={toYear}
              seed={seed}
              resetSeed={this.resetSeed}
            />,
          ]}

          {type === 3 && [<QuizMonth 
            key={0}
            seed={seed} resetSeed={this.resetSeed} />]}
        </div>
      </div>
    );
  }
}

const OptionButton = ({ on, className, children, ...props }) => (
  <button
    {...props}
    className={classNames(className, {
      "--on": on,
    })}
  >
    <span>
      {on && <i>✔</i>} {children}
    </span>
  </button>
);
